<div id="value-filters">
  <div class="row">
    <p class="title">Valores</p>
    <a class="clean-filters">Limpar</a>
  </div>
  <div class="row">
    <div class="one-half">
      <app-range-selector label="Valores de venda" icon="reais" min="0" max="3000000"></app-range-selector>
    </div>
    <div class="one-half">
      <app-range-selector label="Valores de locação" icon="reais" min="0" max="50000"></app-range-selector>
    </div>
  </div>
  <div class="row">
    <app-input id="valor-condominio" class="one-quarter" label="Condomínio (máximo)" placeholder=""
      [iconPathAlt]="{ path: 'reais', alt: 'reais' }">
    </app-input>
    <app-input id="valor-iptu" class="one-quarter" label="IPTU (máximo)" placeholder=""
      [iconPathAlt]="{ path: 'reais', alt: 'reais' }">
    </app-input>
    <app-input id="valor-metro" class="one-quarter" label="Valor do m² (máximo)" placeholder=""
      [iconPathAlt]="{ path: 'reais', alt: 'reais' }">
    </app-input>
    <app-input id="valor-pacote" class="one-quarter" label="Valor do pacote" placeholder=""
      [iconPathAlt]="{ path: 'reais', alt: 'reais' }">
    </app-input>
  </div>
</div>